import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useIsPro } from "@/hooks/useSubscription";

export default function ProGate({
  feature,
  children,
}: {
  feature: string;
  children: React.ReactNode;
}) {
  const isPro = useIsPro();
  if (isPro) return <>{children}</>;
  return (
    <div className="rounded-xl border border-primary/30 bg-primary/5 p-6 text-center">
      <Sparkles className="h-6 w-6 mx-auto text-primary mb-2" />
      <h3 className="font-display text-lg font-semibold text-foreground">
        {feature} is a Pro feature
      </h3>
      <p className="text-sm text-muted-foreground mt-1 mb-4">
        Upgrade to Shareholder Pro to unlock advanced tools and remove limits.
      </p>
      <Button asChild>
        <Link to="/pricing">See plans</Link>
      </Button>
    </div>
  );
}